import { Component, Inject, OnInit,ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderService } from 'app/services/orders.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-detail-sii',
  templateUrl: './dialog-detail-sii.component.html',
  styleUrls: ['./dialog-detail-sii.component.scss']
})
export class DialogDetailSiiComponent implements OnInit {
//############################################################
//############################################################  
errorDTE : any =[]
errorBOL : any =[]
dteData  : any = {}
//############################################################
//############################################################  
  constructor(
              public dialogRef: MatDialogRef<DialogDetailSiiComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private _orderService : OrderService
              ) 
{ 

}
//############################################################
//############################################################  
 async  ngOnInit(){
    let tmp = await this._orderService.getDteDetail(this.data.codDoc,this.data.uuidDTE) 
    this.dteData = tmp.rs
  
    if(this.dteData.COD_DTE_TIPO == 'DTE')
    {
      try{
          //===================================================
          if(this.dteData.XML_ESTADO_ENVIO_CARATULA.RECEPCIONDTE.DETAIL)
              //##
              if(this.dteData.XML_ESTADO_ENVIO_CARATULA.RECEPCIONDTE.DETAIL.isArray== true){
                //$$
                  for(let i=0;i<this.dteData.XML_ESTADO_ENVIO_CARATULA.RECEPCIONDTE.DETAIL.length;i++){
                    this.errorDTE.push({
                                          err: this.dteData.XML_ESTADO_ENVIO_CARATULA.RECEPCIONDTE.DETAIL[i].ERROR
                                          ,det: ""
                    })
                  } 
                //$$              
              }else{
                //$$
                this.errorDTE.push({
                    err: this.dteData.XML_ESTADO_ENVIO_CARATULA.RECEPCIONDTE.DETAIL.ERROR
                   ,det: ""
                  })
                //$$                        
              }
              //##
          //===================================================        
        }catch(e){
          this.errorDTE = []
        }
        //==========================
        try{
            if(this.dteData.XML_RESULTADO_ENVIO_CARATULA.RESULTADO_ENVIO   ){
              //==
                if(this.dteData.XML_RESULTADO_ENVIO_CARATULA.RESULTADO_ENVIO.REVISIONENVIO.REVISIONDTE.isArray== true   ){
                  //$$
                    for(let i=0;i<this.dteData.XML_RESULTADO_ENVIO_CARATULA.RESULTADO_ENVIO.REVISIONENVIO.REVISIONDTE.length;i++){
                      this.errorDTE.push({
                                            err: this.dteData.XML_RESULTADO_ENVIO_CARATULA.RESULTADO_ENVIO.REVISIONENVIO.REVISIONDTE[i].DETALLE   
                                            ,det: ""
                      })
                    } 
                //$$ 
                }else{
                  this.errorDTE.push({
                    err: this.dteData.XML_RESULTADO_ENVIO_CARATULA.RESULTADO_ENVIO.REVISIONENVIO.REVISIONDTE.DETALLE                    
                   ,det: ""
                  })
                }
              //==

            }
        }catch(e){

        }
        
        //==========================          
    }else{
      //##
      try{
         if( this.dteData.XML_RESULTADO_ENVIO_CARATULA.detalle_rep_rech.length > 0      ){
            //
              for(let i=0;i<this.dteData.XML_RESULTADO_ENVIO_CARATULA.detalle_rep_rech.length;i++){
                //##
                console.log(this.dteData.XML_RESULTADO_ENVIO_CARATULA.detalle_rep_rech[i])
                for(let j=0;j<this.dteData.XML_RESULTADO_ENVIO_CARATULA.detalle_rep_rech[i].error.length;j++){
                  console.log(this.dteData.XML_RESULTADO_ENVIO_CARATULA.detalle_rep_rech[i].error[j])
                    this.errorBOL.push({
                      err: this.dteData.XML_RESULTADO_ENVIO_CARATULA.detalle_rep_rech[i].error[j].descripcion
                      ,det: this.dteData.XML_RESULTADO_ENVIO_CARATULA.detalle_rep_rech[i].error[j].detalle
                      })
                }
                //##
              }
            //
          }
      }catch(e){
        this.errorBOL = []
      }
      
      //##    
    }

  }
//############################################################
//############################################################  
closeBtn(){
  this.dialogRef.close();
}
//############################################################
//############################################################ 

//############################################################
//############################################################ 
}
